import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetBettieInfo } from '../../domains/bettie/ui/hooks/useGetBettieInfo';
import type { components } from '../../types/schema';
import useUserQuery from '../hooks/queries/useUserQuery';
import SettingBettieSpeechStyle from './components/SettingBettieSpeechStyle';

type ApiV1MemberPersona = components['schemas']['ApiV1MemberPersona'];

type LocationState =
  | {
      chatRoomUuid: string;
      bettieId: string;
      bettiePersona?: ApiV1MemberPersona;
    }
  | undefined;

const SettingBettieSpeechStylePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  const chatRoomUuid = state?.chatRoomUuid ?? '';
  const bettieId = state?.bettieId ?? '';
  const bettiePersonaFromState = state?.bettiePersona ?? null;

  const { data: bettieInfoData } = useGetBettieInfo(bettieId);
  const bettiePersona = bettiePersonaFromState ?? bettieInfoData ?? null;

  const { data: user } = useUserQuery();
  const isForeignUser = user?.locale !== 'ko';

  // route 직접 진입 방지(필수 정보 없음)
  useEffect(() => {
    if (!chatRoomUuid || !bettieId) {
      navigate(-1);
    }
  }, [bettieId, chatRoomUuid, navigate]);

  if (!chatRoomUuid || !bettieId) return null;
  if (!bettiePersona) return null;

  return (
    <SettingBettieSpeechStyle
      setCurrentStep={(step) => {
        if (step === 'complete') navigate(-1);
      }}
      bettiePersona={bettiePersona}
      chatRoomUuid={chatRoomUuid}
      isForeignUser={isForeignUser}
      otherMoodInputs={{ relationship: '', personality: '', romanceStyle: '' }}
      onBack={() => navigate(-1)}
      updateMode="speech_only"
    />
  );
};

export default SettingBettieSpeechStylePage;
